<template>
  <div class="baseTitle" :class="`baseTitle--${type}`">
    <a v-if="type === 'back'" :href="href" class="baseTitle__back">
      <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.77734 1L0.999169 8.77817L8.77734 16.5563" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
    },
    href: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.baseTitle {
  background: #FF4438;
  font-style: normal;
  font-size: 16px;
  line-height: 32px;
  color: #FFFFFF;
  &--default {
    font-weight: bold;
    letter-spacing: 0.1em;
    text-align: center;
    padding: 11px 0;
  }
  &--back {
    padding: 7px 0 5px 50px;
    position: relative;
    .baseTitle__back {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      padding: 10px 15px 10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/BaseTitle.vue